import { io } from 'socket.io-client';
import config from 'config';
import { LS_KEY_LOGIN_TOKEN } from 'src/constants/localStorageKeys';
import apiClient from 'src/helpers/apiClient';
import { isAdminMode } from 'src/helpers/storedToken';
import { getHeaderDeviceType } from 'src/helpers/utils';

/**
 * The token the socket proves its user with. Normally the stored login,
 * which any tab's refresh keeps fresh. Debug Mode is flagged in storage every
 * tab shares, but only the tab that entered it holds the impersonated token,
 * so then each tab sends the token its own API calls use: the Debug Mode tab
 * is the impersonated user, the admin's other tabs stay the admin.
 */
const socketToken = () =>
  (isAdminMode()
    ? apiClient.apiKey
    : localStorage.getItem(LS_KEY_LOGIN_TOKEN)) || undefined;

const socket = io(config.API_URL, {
  autoConnect: false,
  // v2 socket auth: send the JWT at connect so the notif server derives identity
  // from a verified token instead of a client-declared user_id. Function form →
  // the freshest token is sent on every (re)connect, including after a refresh.
  // `device_type` rides along so presence knows what someone is online from —
  // the same vocabulary as the x-device-type header, so the API and the
  // presence hash never disagree about the same browser.
  auth: (cb) =>
    cb({
      token: socketToken(),
      device_type: getHeaderDeviceType() || undefined,
    }),
});

export default socket;
